import { render, staticRenderFns } from "./login.vue?vue&type=template&id=5c79f808&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./login.vue?vue&type=style&index=1&id=5c79f808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c79f808",
  null
  
)

export default component.exports